import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSettingsStyle0 = cosmosIconCss;

const CosmosIconSettings$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSettings extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e009e0cd47cc3b57c3cfc88c1fa2adce52e7624c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '954e84a658a05d2afa5206ee07f047f472cdf505', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1f3501c05286fff95531d2ac92f171da3045c197', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.782 10.942a6.688 6.688 0 0 0-.044-.733l1.64-1.765a.441.441 0 0 0 .063-.53L17.329 6.01a.432.432 0 0 0-.486-.212l-2.312.547a6.1 6.1 0 0 0-1.297-.697l-.688-2.294A.433.433 0 0 0 12.123 3H9.89a.441.441 0 0 0-.423.318l-.689 2.33c-.462.177-.9.411-1.306.696L5.17 5.797a.441.441 0 0 0-.485.212L3.572 7.933a.45.45 0 0 0 .062.529l1.641 1.765a6.098 6.098 0 0 0 0 1.465l-1.641 1.764a.45.45 0 0 0-.062.53l1.112 1.923a.44.44 0 0 0 .485.212l2.303-.582c.403.288.842.523 1.306.697l.689 2.294a.441.441 0 0 0 .423.318h2.233a.432.432 0 0 0 .423-.318l.688-2.294a5.73 5.73 0 0 0 1.297-.697l2.33.547a.432.432 0 0 0 .485-.212l1.112-1.924a.441.441 0 0 0-.062-.529l-1.64-1.765a6.66 6.66 0 0 0 .026-.714Zm-5.78 4.147a4.147 4.147 0 1 1 0-8.295 4.147 4.147 0 0 1 0 8.295Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSettingsStyle0; }
}, [1, "cosmos-icon-settings", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-settings"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-settings":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSettings$1);
            }
            break;
    } });
}

const CosmosIconSettings = CosmosIconSettings$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSettings, defineCustomElement };
